// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"5fb53f31","313":"75233ede","568":"190f8e14"}[chunkId] + ".css";
};